import React from 'react';
import PropTypes from 'prop-types';

export default class InsertPopoverHint extends React.Component {
    static propTypes = {
        defaultMessage: PropTypes.string
    };

    state = {
        message: this.props.defaultMessage
    };

    setMessage = (message) => {
        this.setState({
            message: message ? message : this.props.defaultMessage
        });
    };

    render() {
        return (
            <div className="help">
                {this.state.message}
            </div>
        );
    }
}